


























import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import BaseIcon from '../base-icon/_base-icon.vue';
import TransitionExpand from '../../transitions/expand/TransitionExpand.vue';

@Component({
  name: 'BaseExpansionPanel',
  components: {
    BaseIcon,
    TransitionExpand,
  },
})
export default class BaseExpansionPanel extends Vue {
  @Model('toggle', { default: false }) expanded: boolean;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) showBorder: boolean;
  @Prop({ default: false }) showShadow: boolean;

  handleToggle() {
    if (this.disabled) {
      return;
    }
    this.$emit('toggle', !this.expanded);
  }
}
